<template>
  <div style="padding: 10px">
    <el-form ref="form" :rules="rules" :model="form" label-width="120px">
      <el-form-item label="姓名" prop="userName">
        <el-input v-model="form.userName" :disabled="true" />
      </el-form-item>
      <el-form-item label="手机号" prop="userPhone">
        <el-input v-model="form.userPhone" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="form.type == 1" label="开户人姓名" prop="name">
        <el-input
          v-model="form.name"
          placeholder="请输入开户人姓名"
          clearable
        />
      </el-form-item>
      <el-form-item v-if="form.type == 2" label="开户企业名称" prop="name">
        <el-input
          v-model="form.name"
          placeholder="请输入开户企业名称"
          clearable
        />
      </el-form-item>
      <el-form-item label="预留手机号" prop="mobile">
        <el-input
          v-model="form.mobile"
          placeholder="请输入预留手机号"
          clearable
        />
      </el-form-item>
      <el-form-item label="银行卡号" prop="account">
        <el-input
          v-model="form.account"
          placeholder="请输入银行卡号"
          clearable
          @input="value => (form.account = value.replaceAll(/\D/g, ''))"
        />
      </el-form-item>
      <!-- 增加银行卡类型  -->
      <el-form-item label="银行卡类型" prop="cardType">
        <el-select
          v-model="form.cardType"
          placeholder="请选择"
          clearable
          filterable
        >
          <el-option
            v-for="item in bankCardTypeList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="开户银行" prop="bankNo">
        <el-select
          v-model="form.bankNo"
          placeholder="请选择"
          clearable
          filterable
          @change="getCityList"
        >
          <el-option
            v-for="item in bankList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="开户行省份" prop="provinceCode">
        <el-select
          v-model="form.provinceCode"
          placeholder="请选择"
          clearable
          filterable
          @change="getCityList"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.provinceCode"
            :label="item.provinceName"
            :value="item.provinceCode"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="开户行城市" prop="cityCode">
        <el-select v-model="form.cityCode" placeholder="请选择" clearable>
          <el-option
            v-for="item in cityList"
            :key="item.cityCode"
            :label="item.cityName"
            :value="item.cityCode"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="paymentType == 'mybank'"
        label="开户网点"
        prop="branche"
      >
        <el-input
          v-model="form.branche"
          placeholder="请输入开户网点"
          clearable
        />
      </el-form-item>
      <el-form-item v-else label="开户网点" prop="branche">
        <el-input
          v-model="form.branche"
          placeholder="请输入内容"
          clearable
          @clear="clearInput()"
          @focus="designatedBank()"
        />
      </el-form-item>
      <el-form-item
        v-if="paymentType == 'mybank'"
        label="联行号"
        prop="bankAssociationNumber"
      >
        <el-input
          v-model="form.bankAssociationNumber"
          placeholder="请输入联行号"
          @input="
            value => (form.bankAssociationNumber = value.replaceAll(/\D/g, ''))
          "
        />
      </el-form-item>
      <el-form-item v-else label="联行号" prop="bankAssociationNumber">
        <el-input
          v-model="form.bankAssociationNumber"
          placeholder="请输入联行号"
        />
        <!-- <el-input v-model="form.bankAssociationNumber" disabled placeholder="请输入联行号" /> -->
      </el-form-item>
      <el-form-item label="账户类型" prop="type">
        <el-radio-group v-model="form.type">
          <el-radio :label="1">
            个人账户
          </el-radio>
          <el-radio :label="2">
            企业账户
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="默认卡" prop="isDefault">
        <el-switch
          v-model="form.isDefault"
          active-color="#13ce66"
          inactive-color="#DDDDDD"
          :active-value="1"
          :inactive-value="0"
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="funcCancel">
          取 消
        </el-button>
        <el-button type="primary" @click="funcSubmit">
          确 定
        </el-button>
      </el-form-item>
    </el-form>
    <BankBranchList ref="BankBranchRef" @event="setBankBranch" />
  </div>
</template>
<script>
import request from "@/utils/request";
import { validatePhone, isSpaceString } from "@/utils/validate.js";
import { isBankCardNum, isBankAssociationNumber } from "@/utils/validate4Form";
import { getListDict } from "@/api/commonApi";
import BankBranchList from "./BankBranchList";
export default {
  name: "BankCardEdit",
  components: {
    BankBranchList
  },
  props: {
    paymentType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      userOptions: [],
      provinceList: [],
      cityList: [],
      bankList: [],
      bankCardTypeList: [],
      form: {},
      rules: {
        partyCode: [
          { required: true, message: "请选择人员", trigger: "change" }
        ],
        name: [
          { required: true, message: "请输入开户人姓名", trigger: "blur" },
          {
            required: true,
            validator(rule, value, callback) {
              isSpaceString(value)
                ? callback(new Error("格式有误"))
                : callback();
            }
          }
        ],
        mobile: [
          {
            required: true,
            validator(rule, value, callback) {
              validatePhone(value)
                ? callback()
                : callback(new Error("手机号格式有误"));
            }
          }
        ],
        account: [
          {
            required: true,
            message: "请输入银行卡号",
            trigger: "blur"
          },
          { validator: isBankCardNum }
        ],
        bankNo: [
          { required: true, message: "请选择开户银行", trigger: "change" }
        ],
        cardType: [
          { required: true, message: "请选择银行卡类型", trigger: "change" }
        ],
        // provinceCode: [
        //   { required: true, message: "请选择开户省份", trigger: "change" }
        // ],
        // cityCode: [
        //   { required: true, message: "请选择开户城市", trigger: "change" }
        // ],
        type: [{ required: true, message: "请选择账户类型", trigger: "blur" }],
        bankAssociationNumber: [{ validator: isBankAssociationNumber }]
        // branche: [
        //   { required: true, message: "请输入开户网点" },
        //   { max: 255, message: "最大长度为255个字符" }
        // ]
      },
      branchCode: ""
    };
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      this.$refs.form.resetFields();
      this.getProvinceList();
      // this.queryUser();
      this.CheckDetails(code);
    },
    //查询详情
    CheckDetails(code) {
      // 查询到数据之前先展示空表单
      request({ url: `/ntocc-basic-api/bankCard/${code}`, method: "get" }).then(
        response => {
          this.form = response.data;
          this.branchCode = response.data.branchCode;
          if (this.form.type == 2) {
            this.rules.name[0].message = "请输入开户企业名称";
          } else {
            this.rules.name[0].message = "请输入开户人姓名";
          }
          this.getFirstCityList();
          this.selectDict();
        }
      );
    },
    // 获取省列表
    getProvinceList() {
      request({ url: "/ntocc-basic-api/areaProvince", method: "get" }).then(
        response => {
          this.provinceList = response.data.records;
        }
      );
    },
    getFirstCityList() {
      this.cityList = [];
      request({
        url: "/ntocc-basic-api/areaCity",
        method: "get",
        params: { provinceCode: this.form.provinceCode }
      }).then(response => {
        this.cityList = response.data.records;
      });
    },
    // 获取市列表
    getCityList() {
      this.form.city = "";
      this.form.cityCode = "";
      this.getFirstCityList();
    },
    // 获取中台银行网点、联行号
    designatedBank() {
      if (!this.form.bankNo) {
        return this.$message.warning("请选择开户银行");
      }
      this.$refs.BankBranchRef.show(this.form.bankNo);
    },
    setBankBranch(data) {
      this.form.branche = data.bankName;
      this.form.bankAssociationNumber = data.bankNo;
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          const data = this.form;
          request({
            url: "/ntocc-basic-api/bankCard",
            method: "put",
            params: data
          }).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
            this.$emit("fatherEditMethod");
          });
        } else {
          return false;
        }
      });
    },
    // 查询人员下拉选
    queryUser(query) {
      if (query !== "") {
        const data = {
          nameOrPhone: query,
          partyTypeList: [
            "DRIVER",
            "DRIVER_LEADER",
            "SHIPMENT",
            "SHIPMENT_COMPANY"
          ]
        };
        request({
          url: "/ntocc-basic-api/party/selectUser",
          method: "post",
          data: data
        }).then(response => {
          this.userOptions = response.data;
        });
      } else {
        this.userOptions = [];
      }
    },
    // 获取数据字典： 银行
    selectDict() {
      getListDict({ types: "bank,cardType", branchCode: this.branchCode }).then(
        response => {
          this.bankList = response.data.filter(item => item.type === "bank")[0][
            "dictList"
          ];
          this.bankCardTypeList = response.data.filter(
            item => item.type === "cardType"
          )[0]["dictList"];
        }
      );
    },
    // 拼接名字和手机
    contractNameAndPhone(item) {
      return item.name + "(" + item.phone + ")";
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "edit");
    }
  }
};
</script>
<style lang="scss" scoped>
.el-date-editor {
  width: 100%;
}
</style>
